import {
    type CountryCode,
    getCountries,
    getCountryCallingCode,
} from 'libphonenumber-js'
import type { Country } from './types'
import { ipwhois } from '@/ui-plus/geolocation-selection-map/ipwhois'
// import { stripeGlobalAvailability } from '@lib/utils/stripe/StripeGlobalAvailability'

export function getBrowserLocale() {
    if (typeof window === 'undefined') {
        return
    }

    const browserLocale = window.navigator.language

    if (!browserLocale) {
        return
    }

    let locale = browserLocale.slice(3, 7).toUpperCase()

    if (locale === '') {
        locale = browserLocale.slice(0, 2).toUpperCase()
    }

    if (locale === 'EN') {
        locale = 'US'
    }
    if (locale === 'JA') {
        locale = 'JP'
    }

    return {
        locale,
        browserLocale,
    }
}

let displayNamesInstance: Intl.DisplayNames | undefined
let displayNamesLocale: string | undefined

export function getCountryName(
    locale: string,
    code: CountryCode | string,
    customCountriesNameListByIsoCode?: Record<CountryCode, string>
): string | undefined {
    //@ts-ignore
    if (customCountriesNameListByIsoCode?.[code]) {
        //@ts-ignore
        return customCountriesNameListByIsoCode[code]
    }

    if (displayNamesLocale !== locale || !displayNamesInstance) {
        displayNamesLocale = locale
        displayNamesInstance = new Intl.DisplayNames([locale], {
            type: 'region',
        })
    }

    return displayNamesInstance.of(code)
}

export function getCountriesList(
    locale?: string,
    customCountriesNameListByIsoCode?: Record<CountryCode, string>
): Country[] | undefined {
    const countriesList: Country[] = []
    const isoList = getCountries()

    locale = locale ?? getBrowserLocale()?.browserLocale ?? 'en-US'

    for (const iso2 of isoList) {
        const name = getCountryName(
            locale,
            iso2,
            customCountriesNameListByIsoCode
        )

        if (name) {
            try {
                const dialCode = getCountryCallingCode(iso2)
                // console.log('!!!dialCode', iso2, dialCode, name)
                // if (stripeGlobalAvailability[iso2 as keyof typeof stripeGlobalAvailability]) {
                countriesList.push({
                    iso2,
                    dialCode,
                    name,
                })
                // }
            } catch (error) {
                console.error(`(getCountryCallingCode) ${error}`)
            }
        }
    }
    countriesList.sort((a, b) => {
        return a.name.localeCompare(b.name)
    })

    // move first item to the end
    // const firstItem = countriesList.shift()
    // if (firstItem) {
    //     countriesList.push(firstItem)
    // }
    // find 'ta' and move to the end
    // const taIndex = countriesList.findIndex(country => country.iso2 === 'TA')
    // if (taIndex !== -1) {
    //     const ta = countriesList.splice(taIndex, 1)[0]
    //     countriesList.push(ta)
    // }

    return countriesList
}

export async function fetchCountryCode() {
    try {
        const ipWhoisResult = await ipwhois()
        const country_code = ipWhoisResult?.country ?? ''
        return country_code
    } catch (error) {
        throw new Error(`(fetchCountryCode) ${error}`)
    }
}

function sanitizePhoneNumber(input?: string) {
    if (!input) {
        return ''
    }
    const regex = new RegExp(/[^\d ()+-]/g) // Keep only digits, (), - and + characters
    //@ts-ignore
    return input.replaceAll(regex, '').trim() // Keep only digits, (), - and + characters
}

export function usePhoneInput() {
    return {
        sanitizePhoneNumber,
        fetchCountryCode,
        getBrowserLocale,
        getCountriesList,
    }
}
